import React from 'react';
import { useState, useEffect } from 'react';
import { Container, Box, Typography } from '@mui/material';
import Banner from "../components/Banner";
import BannerHub from '../components/BannerHub';
import { getWordpressBlog } from '../components/wordpressClient';
import ContactSection from '../components/ContactSection';
import HelpSection from '../components/HelpSection';
import MapSection from '../components/MapSection';
import BlogSection from '../components/BlogSection';
import { Helmet } from 'react-helmet';

export default function Contacto() {
  const [wpData, setWpData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const articles = await getWordpressBlog();
      setWpData(articles);
    };
    fetchData();
  }, []);

  return (
     <>
        <Helmet>
          <title>Contacto | EBM Consultores</title>
          <meta
            name="description"
            content="Consultoría especializada en Empresa Familiar, Gobierno Corporativo y Legado Patrimonial. Descubre cómo acompañamos tu evolución."
          />
        </Helmet>

    <Container sx={{ margin: '0', padding: '0 !important', maxWidth: '100vw !important' }}>
      {/* Banner principal */}
      <Banner
        backgroundImage="https://res.cloudinary.com/dhoyyqszi/image/upload/v1750193258/ebm/seccionContactanosBanner_nz11ni.png"
        title={
          <Typography
            sx={{
              fontSize: { xs: '24px', sm: '38px', md: '46px' },
              lineHeight: 1.2,
              position: 'relative',
              px: { xs: '4vw', sm: '2vw' },
              borderRadius: '50rem',
              background: 'linear-gradient(rgba(10, 98, 116, 0), rgba(10, 98, 116, 0.5))',
              color: 'white',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              backdropFilter: 'blur(10px)',
              WebkitBackdropFilter: 'blur(10px)',
              boxShadow: '0px 2px 10px rgba(0,0,0,0.5)',
              transition: 'box-shadow 0.3s ease, border-color 0.3s ease',
              fontWeight: 500,
              zIndex: 1,
              '&::before': {
                content: '""',
                position: 'absolute',
                inset: 0,
                padding: '1px',
                borderRadius: '50rem',
                background: 'linear-gradient(90deg, #0ff, rgba(10, 98, 116, 0))',
                WebkitMask:
                  'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                WebkitMaskComposite: 'xor',
                maskComposite: 'exclude',
                zIndex: -1,
                transition: 'opacity 0.3s ease',
              },
              '&:hover': {
                boxShadow:
                  '0px -1px 3px rgba(255, 255, 255, 0.3), 0px 2px 10px rgba(0,0,0,0.5)',
                background:
                  'linear-gradient(0deg, rgba(10, 98, 116, 0.5), rgba(10, 98, 116, 0.4))',
                '&::before': {
                  opacity: 0,
                },
              },
            }}
          >
            Conecta con nosotros
          </Typography>
        }
        subtitle={
          <Box
            sx={{
              padding: { xs: "2rem 1rem", sm: "2.2rem 7.2rem" },
              textAlign: { xs: "center", sm: "justify" },
              width: '100%',
              marginBottom: { xs: '8vh', sm: '14vh' }
            }}
          >
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: { xs: '12px', sm: '14px', md: '16px' },
                textShadow: '0px 2px 10px rgba(0,0,0,0.5)',
                maxWidth: { sm: '450px', md: '600px' },
                color: '#D4A76A',
              }}
            >
              Estamos aquí para responder tus preguntas, entender tus necesidades y ofrecer soluciones.
            </Typography>
          </Box>
        }
        variant="bottom-left"
        section="about"
      />

      <ContactSection />
      <HelpSection />
      <MapSection />
      <BlogSection wpData={wpData} />

      {/* Banner final */}
      <Box
        sx={{
          width: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.94)',
          py: { xs: 6, md: 10 },
          px: { xs: 2, md: 10 },
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <BannerHub />
      </Box>
    </Container>
    </>
  );
}